export const FORM_LIST = '/form-list'
export const FORM = '/form'
export const FORM_FORMS = `${FORM}/forms`
export const FORM_TYPE = `${FORM}/type`
export const FORM_INCOMING_FORMS = `/incoming-forms`
export const FORM_CREATE = `${FORM}/create`
export const FORM_REQUEST = '/request-form'
export const FORM_REQUEST_CREATE = `${FORM_REQUEST}/create/:id`
export const FORM_FORMS_FOR_STUDENT = '/forms-for-student'
